<div id="general" class="category-content active">
    <div class="stats-grid">
        <div class="stat-card">
            <span class="stat-number">42</span>
            <div class="stat-label">Jugadores Inscritos</div>
        </div>
        <div class="stat-card">
            <span class="stat-number">4</span>
            <div class="stat-label">Categorias</div>
        </div>
        <!-- <div class="stat-card">
            <span class="stat-number">6</span>
            <div class="stat-label">Clubes</div>
        </div> -->
    </div>

    <div class="rules-grid">
        <div class="rule-card">
            <div>
                <svg width="80px" height="80px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 17V11" stroke="#ff6b35" stroke-width="1.5" stroke-linecap="round" />
                    <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#ff6b35" />
                    <path
                        d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                        stroke="#ff6b35" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </div>
            <div class="rule-list">
                <ul>
                    <li>Todos los partidos se jugarán a 2 de 3 games.</li>
                    <li>Serán premiados Campeón y Subcampeón</li>
                    <li>Los jugadores de sus grupos deben arbitrar los partidos de su cuadro</li>
                    <li>Uso de gafas es obligatorio</li>
                    <li>Los partidos se citan a cada categoría en el rango de de tiempo se jugarán los partidos asignamos por la mesa de control (los jugadores deben asegurar presencia en el rango de la categoría que le corresponde). </li>
                    <li>El buen comportamiento es fundamental para el buen desarrollo del torneo la buena conducta deportiva hace que nuestro deporte sea más sano y familiar tanto para deportistas como padres de familia o acompañantes</li>
                </ul>
            </div>
        </div>
    </div>

    <h3 style="margin-bottom: 20px; color: #ff6b35; text-align: center;">Programación por bloques</h3>

    <div class="tab-content" style="display: block; margin-bottom: 2rem;">
        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Viernes 10 de Octubre</h3>
            <div class="info">
                <div class="time"><span>desde</span>09:00 a.m. <br><span>hasta</span>11:00 a.m.</div>
                <div class="players">Juvenil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>03:00 p.m. <br><span>hasta</span>04:30 p.m.</div>
                <div class="players">Juvenil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>04:30 p.m. <br><span>hasta</span>05:30 p.m.</div>
                <div class="players">Damas</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>04:30 p.m. <br><span>hasta</span>05:30 p.m.</div>
                <div class="players">Intermedia</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:00 p.m.</div>
                <div class="players">Avanzados</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>06:30 p.m.</div>
                <div class="players">Intermedia</div>
            </div>
        </div>

        <div class="info-schedule">
            <h3 style="margin-bottom: 20px; color: #ff6b35;">Sábado 11 de Octubre</h3>
            <div class="info">
                <div class="time"><span>desde</span>09:00 a.m.</div>
                <div class="players">Cuartos: Juvenil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>10:30 a.m.</div>
                <div class="players">Semifinal: Juvenil</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>11:30 a.m.</div>
                <div class="players">Final: Juvenil</div>
            </div>

            <div class="info">
                <div class="time"><span>desde</span>09:00 a.m.</div>
                <div class="players">Semifinal: Damas</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>11:00 a.m.</div>
                <div class="players">Final: Damas</div>
            </div>

            <div class="info">
                <div class="time"><span>desde</span>09:00 a.m.</div>
                <div class="players">Cuartos: Intermedia</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>11:00 a.m.</div>
                <div class="players">Semifinal: Intermedia</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>11:45 a.m.</div>
                <div class="players">Final: Intermedia</div>
            </div>

            <div class="info">
                <div class="time"><span>desde</span>10:30 a.m.</div>
                <div class="players">Semifinal: Avanzados</div>
            </div>
            <div class="info">
                <div class="time"><span>desde</span>12:00 p.m.</div>
                <div class="players">Final: Avanzados</div>
            </div>
        </div>
    </div>
</div>